/* eslint-disable operator-linebreak */
const isLocalhost = process.env.NODE_ENV === 'development';
export const baseUrl = isLocalhost
  ? 'http://127.0.0.1:5001/api/v1'
  : 'https://api.davsafaris.com/api/v1';

export const DAV_MAIN_DOMAIN = 'https://davsafaris.com';

export const DAV_ROLES = {
  ADMIN: 'admin',
  AGENT: 'agent',
  SUPER_ADMIN: 'super_admin',
  CONTENT_MANAGER: 'content_manager',
  TOUR_OPERATOR: 'tour_operator',
  CLIENT: 'client',
};

export const STAFF_ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'content_manager', label: 'Content Manager' },
  { value: 'tour_operator', label: 'Tour Operator' },
];

export const CURRENT_VERSION = '1.2.24';

export const FILE_UPLOAD_BOX_STYLES =
  'w-full border border-dashed border-[#cbd6e2]  h-[230px] bg-[#f5f8fa] rounded-md flex justify-center items-center cursor-pointer hover:border-secondary';

export * from './schemas';
export * from './interfaces';
